function normalizeText(text) {
  return text
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

export function translateOptinText(text, i18n) {
  if (!text || i18n.locale === 'pt-BR') return text

  const normalized = normalizeText(text)

  if (
    normalized.includes('aceite') &&
    (normalized.includes('termos de uso') || normalized.includes('termo de uso')) &&
    normalized.includes('privacidade')
  ) {
    return i18n.t('cadastro.acceptTermsPrivacy')
  }

  if (
    (normalized.includes('termos de uso') || normalized.includes('termo de uso')) &&
    normalized.includes('privacidade')
  ) {
    return i18n.t('cadastro.termsOfUsePrivacy')
  }

  return text
}
